import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import GlobalRegistriesContent from './GlobalRegistriesContent';
import TileHeader from '../../components/TileHeader/TileHeader';
import NewGlobalRegistryModal from './NewGlobalRegistryModal';
import DeleteGlobalRegistryModal from './DeleteGlobalRegistryModal';
// api
import { getAllGlobalRegistries } from '../../api/global-registries';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const GlobalRegistries = ({
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

  const [globalRegistriesList, setGlobalRegistriesList] = useState(null);
  const [openNewGlobalRegistryModal, setOpenNewGlobalRegistryModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [openGlobalRegistryModal, setOpenGlobalRegistryModal] = useState(false);
  const [detailModalMode, setDetailModalMode] = useState("create");
  const [globalRegistry, setGlobalRegistry] = useState(null);

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Global registries report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('globalRegistries')
      .then(({ task_id }) => {
        toaster('Generating global registries report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  const refreshGlobalRegistriesList = async () => {
    
    setLoading(true);
    let data = await getAllGlobalRegistries();
    setGlobalRegistriesList(data); 
    if(data){
      setLoading(false);
    }
  }
  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const closeModal = () => {
    setOpenGlobalRegistryModal(false);
    setGlobalRegistry(null);
  };
  
  const addNewGlobalRegistry = () => {
    openGlobalRegistryModal(true);
  };

  useEffect(async () => {
    refreshGlobalRegistriesList();
  }, []);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
            title="Global Registries"
            subtitle="A list of all global registries."
            size="lg"
        />

        
				

        <GlobalRegistriesContent
          globalRegistriesList={globalRegistriesList}
          setOpenNewGlobalRegistryModal={setOpenNewGlobalRegistryModal}
          onDeleteClicked={showDeleteConfirm}
          setOpenNewGlobalRegistryModal={setOpenGlobalRegistryModal}
          setDetailModalMode={setDetailModalMode}
          setGlobalRegistry={setGlobalRegistry}
          setMode={setDetailModalMode}
          onGenerateReport={() => setOpenReportModal(true)}
          reportStatus={reportStatus}
          />

        <NewGlobalRegistryModal
          open={openGlobalRegistryModal}
          globalRegistryData={globalRegistry}
          refreshList={refreshGlobalRegistriesList}
          onClose={closeModal}
          mode={detailModalMode}
        />
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
        <DeleteGlobalRegistryModal
          open={openDeleteModal}
          refreshList={refreshGlobalRegistriesList}
          onClose={() => setOpenDeleteModal(false)}
          globalRegistryList={globalRegistriesList}
          deleteItem={deleteItem}
        />
        
      </ContentContainer>
    </Container>
  );
};

export default GlobalRegistries;